(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  if (!document.documentElement.hasAttribute('data-aaronya-filter-shortcuts')) {
    document.documentElement.setAttribute('data-aaronya-filter-shortcuts', '');
    document.addEventListener('click', (event) => {
      const shortcut = event.target.closest('[data-aaronya-filter-shortcut]');
      if (!shortcut) return;

      const target = shortcut.dataset.aaronyaFilterShortcut;
      window.setTimeout(() => {
        const drawer = document.querySelector('#filters-drawer');
        if (!drawer) return;

        const detailsGroups = Array.from(drawer.querySelectorAll('details'));
        detailsGroups.forEach((details) => {
          details.open = false;
        });

        const drawerScroller = drawer.querySelector('.facets-drawer__filters');
        if (drawerScroller) drawerScroller.scrollTop = 0;

        if (target === 'all') {
          const drawerHeading = drawer.querySelector('#filters-drawer-heading');
          drawerHeading?.focus();
          return;
        }

        if (target === 'sort') {
          const sortSummary = Array.from(drawer.querySelectorAll('summary')).find((item) =>
            item.textContent.trim().toLowerCase().startsWith('sort')
          );
          const sortDetails = sortSummary?.closest('details');
          if (sortDetails) sortDetails.open = true;
          sortSummary?.focus();
          sortSummary?.scrollIntoView({ block: 'start' });
          return;
        }

        const summaries = Array.from(drawer.querySelectorAll('summary'));
        const summary = summaries.find((item) => item.textContent.trim().toLowerCase().startsWith(target));
        if (!summary) return;

        const details = summary.closest('details');
        if (details) details.open = true;
        summary.focus();
        summary.scrollIntoView({ block: 'center' });
      }, 180);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
